module.exports = __webpack_public_path__ + "4f67ea6c7017b12424eeb0aef6914eab.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/logo-drm.png
// module id = 647
// module chunks = 0